module.exports = __webpack_public_path__ + "static/media/servicios-2.156c6e70.png";